<template>
  <v-autocomplete
        v-model="place"
        :items="items"
        :loading="isLoading"
        :search-input.sync="search"
        color="white"
        hide-no-data
        hide-selected
        item-text="description"
        item-value="id"
        label="Search for places"
        placeholder="Start typing to Search"
        return-object
        @change="handleSelectPlace()"
        clearable
      ></v-autocomplete>
</template>
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
export default {
  data: () => ({
    items: [],
    place: null,
    search: null,
    isLoading: false,
    sessionToken: null,
  }),
  computed: {
    ...mapState([]),
  },
  methods: {
    ...mapActions(['searchPlacesAutocomplete', 'addNewPlace']),
    handleSelectPlace(){
      if (this.place) {
        this.addNewPlace(this.place).then(()=>{
          this.place=null;
          this.search=null; 
          this.items=[];
          this.isLoading = false;
          this.sessionToken = null; 
        });
      }
    }
  },
  watch: {
      search (val) {
        if (!this.sessionToken) this.sessionToken = new google.maps.places.AutocompleteSessionToken();
        if (val) {
          this.searchPlacesAutocomplete(val, this.sessionToken).then(r=>{
            this.items = r
          }).catch(err=>{
          })
        }
      },
      place () {
      },
    },
};
</script>
